export default {
  telefonesuteis: [],
}
